// Helpers used directly by or in markup code

import $ from "jquery"; // Remove me if jQuery isn't necessary

/* istanbul ignore next */
function init(): void {
  // Add a hover class to the body when mouse movement is detected, disable it when touch events are.
  // This approach caters to devices which support both mouse and touch, by basing the behaviour on which kind of interaction they're currently doing
  function watchForHover() {
    let hasHoverClass = false;
    let lastTouchTime = new Date().getTime();

    function enableHover() {
      // filter emulated events coming from touch events
      if (new Date().getTime() - lastTouchTime < 500) return;
      if (hasHoverClass) return;

      document.body.className += " has-hover";
      hasHoverClass = true;
    }

    function disableHover() {
      if (!hasHoverClass) return;

      const container = document.body;
      container.className = container.className.replace(" has-hover", "");
      hasHoverClass = false;
    }

    function updateLastTouchTime() {
      lastTouchTime = new Date().getTime();
    }

    document.addEventListener("touchstart", updateLastTouchTime, true);
    document.addEventListener("touchstart", disableHover, true);
    document.addEventListener("mousemove", enableHover, true);

    enableHover();
  }

  watchForHover();

  // Not to be confused with utils > toggle class - this one's used directly in markup code
  function toggleClass($this) {
    if ($this.attr("data-class")) {
      const className = $this.data("class");
      if ($this.attr("data-target")) {
        const target = $this.data("target");
        $(target).toggleClass(className);
        $this.toggleClass(className);
      } else {
        $this.toggleClass(className);
      }
    }
  }

  // Click on this element toggles given class on the target element, stops default event
  $(".js-toggle-class").click(function()
  {
    toggleClass($(this));
    return false;
  });

  // Changing this element toggles given class on the target element (likely use is on input[type=checkbox])
  $(".js-toggle-class-on-change").change(function()
  {
    toggleClass($(this));
  });

  $(".js-stop-propagation").click(function(e)
  {
    e.stopPropagation();
  });

  // Elements that have disability based on form inputs should check the values of those forms on load
  $(".js-check-disability-on-load").each(function()
  {
    const $this = $(this);
    if ($this.attr("data-disabled-by")) {
      const disabledBy = $this.data("disabled-by");
      const $disabledBy = $(disabledBy);
      if ($disabledBy.is(":checked")) {
        $this.removeClass("disabled");
      } else {
        $this.addClass("disabled"); // It's probably in the initial markup anyway, but just to be safe...
      }
    }
  });

  const loadOnSelect = document.querySelectorAll<any>(".js-load-on-select"); // Typing as any as it can be either an HTMLSelectElement or  an anchor

  loadOnSelect.forEach(selEl =>
  {
    selEl.onchange = function()
      {
        window.open(this.value, "_self");

        // Keep the selection open after click?
        if (!selEl.dataset.persist) {
          this.options[0].selected = true;
        }
      };
  });
}

export default { init };
